import { render, staticRenderFns } from "./RestrictedLayout.vue?vue&type=template&id=27a5f2ef"
import script from "./RestrictedLayout.vue?vue&type=script&lang=js"
export * from "./RestrictedLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports